import React, { useEffect, useState, useRef } from "react";
import "./home.css"
import axios from "axios"

import logo_animated from "../../assets/beats/logo.gif"
import swirl from "../../assets/beats/swirl.svg"
import Header from "./Header/Header"
import useSound from "use-sound";

export default function Home(){
    const [beats, setBeats] = useState([])
    const [selectedBeat, setSelectedBeat] = useState("")

    const [hasLoaded, setHasLoaded] = useState(false)
    const [isPlaying, setIsPlaying] = useState(false) // I will use you to check whether a music is playing. If so, i will check the music, update the icons.
    const audioRef = useRef() // I will use you to select an audio to set the audio that will play or not


    function getBeats(url){
        fetch(url)
            .then((res) => res.json())
            .then(data => {
                setBeats(data.results)
                setHasLoaded(true)
            })
    }

    useEffect(()=>{
        getBeats("https://beatsapi.ilemlembo.me/api/freeBeats/")
    }, 
    [])
    




    

    function pause(){

        setIsPlaying(false);
        audioRef.current.pause()
    }
    
    function play(){
        
        setIsPlaying(true);
        audioRef.current.play()
    }
    
    function handleBeatPlay(beat_url){

        setSelectedBeat(beat_url)

        if(beat_url === selectedBeat){
            setIsPlaying(false)
            audioRef.current.load(beat_url)
        }
       

        if(isPlaying){
            pause()
        }else{
            play()
        }
    }



    return(
        <React.Fragment>

            <header>

                <a href="/"><img src={logo_animated} alt="logo" className="home--logo"/></a>
                <ul>
                    <li>About</li>
                    <hr></hr>
                    <li>My Works</li><hr></hr>
                    <li>My Contact</li>
                </ul>
            
            </header>

            <section className="intro">

                <div className="intro--element--Container">
                    <h1><span>Welcome,</span> My name is Ilem Nelson LEMBO. And, obviously I am a <span>BeatMaker and a WebDevelopper</span> <span style={{color:"red"}} >.</span>

                        <p>I'm a Beatmaker who uses cutting-edge technology and creative techniques to produce fresh and captivating beats that connect with audiences.
                            With a strong background in music theory and production software, I'm dedicated to pushing the boundaries of what's possible in beatmaking and bringing new ideas to the table.
                            My passion for music and commitment to innovation drives me to create beats that stand out and leave a lasting impression.
                        </p>
                    
                    </h1>

                    <ul className="intro--menu">

                        <li><i class="fa-solid fa-headphones"></i> My Works 
                            <span></span><span></span><span></span><span></span>
                        </li>
                        <li><i class="fa-solid fa-envelope-open"></i> Contact Me
                            <span></span><span></span><span></span><span></span>
                            <span></span><span></span><span></span><span></span>
                        </li>
                    
                    </ul>
                
                </div>
                
            </section>
                {/* 
            <a href="#my-work" className="head--to-container"><img src={swirl} alt="button" className="head--to playing"/></a> */}

            



            <section className="my-work" id="my-work">

                <div className="description">
                    <h3>Ilem Nelson LEMBO</h3>

                    <h1>GET IN TOUCH</h1>

                    <div className="description--contact">

                        <h3>My Email:</h3>
                        <a href="mailto:devlembojunior@gmail.com">hello@ilemlembo.com</a>
                        <br/>
                        <br/>
                        <br/>
                        <span><h3>OPEN FOR COLLABS</h3></span>
                    
                    </div>
                
                </div>

                <div className="beats">
                    <h1 className="for--pc">Here are a selection of my works, Enjoy, and kindly leave a mail. I will appreciate it!</h1>
                    <h1 className="for--mobile">Hey, You can come to the same page with a Desktop if you want to hear some of my projects.<br/><br/><small>Suggestion : I Suggest that you come with a headphone!</small></h1>
                    {hasLoaded && <ul>
                        {beats.map(beat =>{
                            return <li className="beat" key={beat.id}>
                                <div className="beat--detail">
                                    <h2>TITLE : {beat.title}</h2>
                                    <h3>GENRE : {beat.genre}</h3>
                                </div>
                                <div className="play--button" onClick={()=>handleBeatPlay(beat.file)}>

                                {selectedBeat === beat.file && !isPlaying ? <i class="fa-solid fa-circle-play"></i> : <i class="fa-solid fa-circle-play"></i>}

                                
                                </div>
                            
                                </li>
                            }
                        )}
                    
                    </ul>}
                
                </div>
            
            </section>

            <audio src={selectedBeat} ref={audioRef} className="audio_player" />


            <div className="button--for_contact"><i class="fa-solid fa-paper-plane"></i></div>
            
            <footer>

                <ul>
                    <li><a target="_blank" rel="noreferrer" href="https://twitter.com/LEMBOEdem"><i class="fa-brands fa-twitter"></i></a></li>
                    <li><a target="_blank" rel="noreferrer" href="https://linkedin.com/in/ilemjuniorlembo"><i class="fa-brands fa-linkedin"></i></a></li>
                    <li><a target="_blank" rel="noreferrer" href="https://t.me/ilemJuniorlembo"><i class="fa-brands fa-telegram"></i></a></li>
                </ul>
            
                <div className="copyright">&copy; {new Date().getFullYear()} Ilem Jr. LEMBO All rights reserved.</div>
            </footer>
        
        </React.Fragment>
    )
}